/**
 * Insurer product endpoints (used by product-management list page).
 * Same backend as insurance-management; kept there as well.
 */
const INSURER_PRODUCT_BASE = "/product/v1/internal/products/insurer";

/**
 * Partner product endpoints (used by bank Products tab / useBankProducts).
 * Backend: GetPartnerProductForDashboardList, GetPartnerProductDetail, SoftDeletePartnerProducts, EditPartnerProducts.
 */
const PARTNER_PRODUCT_BASE = "/product/v1/internal/products/partner";

export default {
  // Insurer product (product-management list page)
  getInsurerProductList: {
    method: "get",
    url: `${INSURER_PRODUCT_BASE}/list`,
  },
  updateInsurerProduct: {
    method: "patch",
    url: `${INSURER_PRODUCT_BASE}/:id`,
  },
  deleteInsurerProduct: {
    method: "delete",
    url: `${INSURER_PRODUCT_BASE}/:id`,
  },

  // Partner product (bank Products tab)
  getPartnerProductList: {
    method: "get",
    url: `${PARTNER_PRODUCT_BASE}/list`,
  },
  getPartnerProductDetail: {
    method: "get",
    url: `${PARTNER_PRODUCT_BASE}/detail/:product_code`,
  },
  deletePartnerProduct: {
    method: "delete",
    url: `${PARTNER_PRODUCT_BASE}/:product_code`,
  },
  updatePartnerProduct: {
    method: "patch",
    url: `${PARTNER_PRODUCT_BASE}/:product_code`,
  },
  addPartnerProduct: {
    method: "post",
    url: "/product/v1/products/relations",
  },
  // Bank config (bank Products tab)
  getBankConfig: {
    method: "get",
    url: "/product/v1/internal/products/bank-configs/:bank_code",
  },
  updateBankConfig: {
    method: "put",
    url: "/product/v1/internal/products/bank-configs/:bank_code",
  },
  addBankConfig: {
    method: "post",
    url: "/product/v1/internal/products/bank-configs",
  },
};
